import React, { Component } from 'react'
import styled from 'styled-components'

const ContactWrapper = styled.form`
  input,
  textarea {
    background: transparent;
  }
  button {
  }
  textarea {
  }
  input,
  textarea {
    &::placeholder {
      opacity: 1;
      // color: white !important;
    }
  }
  input,
  textarea,
  button {
    color: #fff;
    border: solid 3px #387b90;
    ::placeholder {
      color: #fff;
    }
    &:active,
    &:focus,
    &:hover {
      border: solid 3px #387b90;
    }
  }
`

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

export default class Contact extends React.Component {
  constructor(props) {
    super(props)
    this.state = { name: '', email: '', subject: '', message: '' }
  }

  handleSubmit = e => {
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': 'contact',
        'name-input': 'name',
        'email-input': 'email',
        'subject-input': 'subject',
        'message-input': 'message',
        ...this.state,
      }),
    })
      .then(() =>
        alert(
          'Thank you for reaching out! We will get back to you shortly. We are literally running, literally, to answer your message!'
        )
      )
      .catch(error => alert(error))

    this.setState({ name: '', email: '', subject: '', message: '' })
    e.preventDefault()
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  render() {
    const { name, email, subject, message } = this.state
    return (
      <ContactWrapper
        action="/success"
        method="post"
        name="contact"
        data-netlify
        data-netlify-honeypot="bot-field"
        onSubmit={this.handleSubmit}
        className="has-background-dark"
      >
        <p hidden>
          <label>
            Don’t fill this out: <input name="bot-field" />
          </label>
        </p>
        <div>
          <div className="control">
            <div className="field">
              <input
                type="text"
                placeholder="Name"
                className="input has-background-transparent "
                required
                name="name"
                onChange={this.handleChange}
                value={this.state.name}
              />
            </div>
            <div className="field">
              <input
                type="email"
                placeholder="Email"
                className="input has-background-transparent "
                required
                name="email"
                onChange={this.handleChange}
                value={this.state.email}
              />
            </div>
            <div className="field">
              <input
                type="tel"
                placeholder="(555) 555-5555"
                className="input has-background-transparent "
                required
                name="subject"
                onChange={this.handleChange}
                value={this.state.subject}
              />
            </div>
            <div className="field ">
              <textarea
                type=""
                placeholder="Message..."
                className="textarea has-background-transparent"
                required
                rows="5"
                name="message"
                onChange={this.handleChange}
                value={this.state.message}
              />
            </div>
            <div className="control">
              <div data-netlify-recaptcha />

              <button className="button is-fullwidth is-primary" value="Send">
                Submit
              </button>
            </div>
          </div>
        </div>
      </ContactWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/contact-form.js